<script>
    import { months } from './util';

    export let monthId = null;

    let month = monthId ? monthId % 12 : null;
    let year = monthId ? Math.floor(monthId / 12) + 1970 : null;

    $: {
        if (month !== null && year !== null) {
            monthId = (year - 1970) * 12 + month;
        }
    }
</script>

<select bind:value={month}>
    {#each months as month, i}
        <option value={i}>{month}</option>
    {/each}
</select>
<input type=number min="1990" max="2200" required bind:value={year}>